import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../../components/custom/BackButton';
import { IFile } from '../../../../globals/interfaces';
import ActionIcon from '../../../../components/custom/ActionIcon';
import FileBase64 from 'react-file-base64';
import { FormInputProps } from '../../../../components/custom/hookForm/FormInput';
import { OmitProps } from '../../../../components/custom/hookForm/useTypedForm';
import { IRampReportWithFiles } from '.';
import { notify } from '../../../../utils';
import _ from 'lodash';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    files: Array<IFile>;
    setFiles: (files: Array<IFile>) => void;
    submitReport: () => Promise<void>;
}

export default function ModalAddRampReport({
    modal,
    setModal,
    submitReport,
    files,
    setFiles
}: Props) {

    const [fileInputKey, setFileInputKey] = useState(0);
    const [loading, setLoading] = useState(false); 

    const enableSubmitDamageReport = 
        _.get(files, 'length', 0) > 0;

    const toggle = () => setModal(!modal);

    const handleSubmitReport = async () => {
        setLoading(true);
        await submitReport();
        setLoading(false);
        toggle();
        notify('Report submitted');
    }

    const reset = () => {
        setFiles([]);
        setFileInputKey(fileInputKey + 1);
    }

    useEffect(() => {
        reset();
    }, [modal]);

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Add Ramp Report</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <FileBase64
                    multiple={true}
                    onDone={setFiles}
                    key={fileInputKey}
                />
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        <ActionIcon 
                            type={'save'} 
                            onClick={() => handleSubmitReport()}    
                            disabled={!enableSubmitDamageReport}
                            loading={loading}
                        />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;